export default __webpack_public_path__ + "static/media/m052.45f53a76.svg";